






import {Component, Prop, Vue} from 'vue-property-decorator';
import ImageManager from '@/script/ImageManager';

@Component
export default class MainImage extends Vue {
  @Prop({ type: String, required: true })
  private target!: string;

  private mainImageUrl: string = '';

  private created() {
    this.mainImageUrl = ImageManager.INSTANCE.get(this.target)!;
  }
}
